/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';
import { Box } from '@mui/material';
import { ClassNameMap } from '@mui/styles';
import { FormikFieldEnum, useAutopopulateFormikValue } from './MissionDetailsForm';
import SelectBox from './SelectBox';
import { FilterOptionsState } from '@mui/material/useAutocomplete';
import { shallowEqual, useSelector } from 'react-redux';
import { selectMissionPlanById } from '../../../store';
export interface MarginalServiceSelectsProps {
  styling: ClassNameMap<'label' | 'input' | 'error'>;
}

const MarginalServiceSelects = (props: MarginalServiceSelectsProps) => {
  const { styling } = props;
  const optionsTakeoffAndLanding: string[] = ['0', '5', '10', '15', '20', '25', '30'];
  const optionsHandoff: string[] = ['5', '10', '15', '20'];
  const missionPlanToEdit = useSelector(selectMissionPlanById, shallowEqual);

  //  Populates marginal service fields when editting a plan
  useAutopopulateFormikValue(
    FormikFieldEnum.TAKEOFF_BUFFER,
    missionPlanToEdit.takeOffBuffer ? missionPlanToEdit.takeOffBuffer : 15,
  );
  useAutopopulateFormikValue(
    FormikFieldEnum.HANDOFF_BUFFER,
    missionPlanToEdit.handOffBuffer ? missionPlanToEdit.handOffBuffer : 10,
  );
  useAutopopulateFormikValue(
    FormikFieldEnum.LANDING_BUFFER,
    missionPlanToEdit.landingBuffer ? missionPlanToEdit.landingBuffer : 15,
  );

  // Custom filter fcn to decide which options to display based on input
  const filter = (options: any[], state: FilterOptionsState<any>) => {
    let existingOptionLabels = [
      '0 Minutes',
      '5 Minutes',
      '10 Minutes',
      '15 Minutes',
      '20 Minutes',
      '25 Minutes',
      '30 Minutes',
    ];

    //Make inputValue empty if it matches an existing option label
    state.inputValue = existingOptionLabels.includes(state.inputValue) ? '' : state.inputValue;

    return options.filter(option => (option + ' minutes').includes(state.inputValue.toLowerCase()));
  };

  return (
    <React.Fragment>
      <Box flexBasis="31%">
        <label htmlFor={FormikFieldEnum.TAKEOFF_BUFFER} className={styling.label}>
          Marginal service (Takeoff)*
        </label>
        <SelectBox
          options={optionsTakeoffAndLanding}
          fieldName={FormikFieldEnum.TAKEOFF_BUFFER}
          isDisabled={false}
          filter={filter}
        />
      </Box>
      <Box flexBasis="31%">
        <label htmlFor={FormikFieldEnum.HANDOFF_BUFFER} className={styling.label}>
          Marginal service (Handoff)*
        </label>
        <SelectBox
          options={optionsHandoff}
          fieldName={FormikFieldEnum.HANDOFF_BUFFER}
          isDisabled={false}
          filter={filter}
        />
      </Box>
      <Box flexBasis="31%">
        <label htmlFor={FormikFieldEnum.LANDING_BUFFER} className={styling.label}>
          Marginal service (Landing)*
        </label>
        <SelectBox
          options={optionsTakeoffAndLanding}
          fieldName={FormikFieldEnum.LANDING_BUFFER}
          isDisabled={false}
          filter={filter}
        />
      </Box>
    </React.Fragment>
  );
};

export default MarginalServiceSelects;
